module.exports = __webpack_public_path__ + "static/media/project1.4604a57a.png";